module.exports = __webpack_public_path__ + "img/member_ic3_record.936f56be.png";